import { AlertTriangle, ChevronDown, ChevronRight } from "lucide-react";

import { Badge } from "@components/ui/badge";
import { Checkbox } from "@components/ui/checkbox";
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip";

import { formatDocumentCategory } from "../utils/classificationMapper";

type DocumentTypeHeaderProps = {
  title: string;
  count: number;
  isCollapsed: boolean;
  isSelected?: boolean;
  isPartiallySelected?: boolean;
  onToggleCollapse: () => void;
  onSelectGroup?: (selected: boolean) => void;
  selectable?: boolean;
  warningMessage?: string;
};

export const DocumentTypeHeader = ({
  title,
  count,
  isCollapsed,
  isSelected,
  isPartiallySelected,
  onToggleCollapse,
  onSelectGroup,
  selectable = false,
  warningMessage,
}: DocumentTypeHeaderProps) => {
  return (
    <div className="flex w-full min-w-[800px] items-center">
      {selectable && (
        <div className="w-[48px] flex-shrink-0 p-0">
          <div className="flex min-h-[46px] items-center justify-center">
            <Checkbox
              checked={isSelected}
              className={
                isPartiallySelected ? "data-[state=checked]:bg-primary/50" : ""
              }
              onCheckedChange={(checked) => onSelectGroup?.(!!checked)}
              onClick={(e) => e.stopPropagation()}
              aria-label={`Select all ${title} files`}
            />
          </div>
        </div>
      )}
      <div
        className="w-[250px] flex-shrink-0 cursor-pointer p-3"
        onClick={onToggleCollapse}
      >
        <div className="flex min-w-max items-center gap-2">
          {isCollapsed ? (
            <ChevronRight className="text-muted-foreground h-4 w-4" />
          ) : (
            <ChevronDown className="text-muted-foreground h-4 w-4" />
          )}
          <p className="inline-block text-sm font-medium text-foreground">
            {formatDocumentCategory(title)}
          </p>
          <Badge variant="default" className="px-2 py-0 text-[10px] font-medium">
            {count}
          </Badge>
          {warningMessage && (
            <Tooltip>
              <TooltipTrigger asChild>
                <figure className="flex items-center gap-1 rounded-full bg-warning-50 px-2 py-0.5 text-warning">
                  <AlertTriangle className="size-3" />
                  <span className="text-[10px] font-medium">Only 1 allowed</span>
                </figure>
              </TooltipTrigger>
              <TooltipContent className="max-w-xs">
                <p>{warningMessage}</p>
              </TooltipContent>
            </Tooltip>
          )}
        </div>
      </div>
      <div className="w-[200px] flex-shrink-0 p-3"></div>
      <div className="w-[300px] flex-shrink-0 p-3"></div>
      <div className="w-[200px] flex-shrink-0 p-3"></div>
    </div>
  );
};
